
import React, {useEffect, useState} from 'react';
import {func, object, string} from 'prop-types';
import {isUndefined} from 'lodash';

import {
    DAILY_WEEKLY_TOGGLE_TAB,
    computeData,
    getFromToDate,
    generateDatesBetween
} from '../charts-util.js';
import {getStructuralChartConfig} from './chart-recommendation-structural-config.js';
import {CHART_TYPE} from '../../../../ui-components/chart-wrapper/chart-constants.js';

import ChartPanel from '../../../../ui-components/chart-panel/chart-panel.jsx';

const ChartRecommendationStructural = ({
    filteredStructuralSummaryData,
    searchCriteriaPayload,
    recommendationStatus,
    updateFilteredStructuralSummaryData,
    barOnClickHandler = () => {},
    gridChartIconOnClickHandler = () => {},
    filterBy
}) => {
    const [barChart, setBarChart] = useState([]);
    const [dailyWeeklyTabValue, setDailyWeeklyTabValue] = useState(DAILY_WEEKLY_TOGGLE_TAB.DAILY);

    const fromTo = getFromToDate(searchCriteriaPayload);
    const datesInSequence = generateDatesBetween(fromTo);

    const handleDailyWeeklyTabOnClick = value => {
        setDailyWeeklyTabValue(value);
    };

    useEffect(() => {
        setBarChart(computeData(filteredStructuralSummaryData, recommendationStatus, datesInSequence, dailyWeeklyTabValue, filterBy));
    }, [filteredStructuralSummaryData]);

    useEffect(() => {
        setDailyWeeklyTabValue(DAILY_WEEKLY_TOGGLE_TAB.DAILY);
        updateFilteredStructuralSummaryData(recommendationStatus);
    }, [recommendationStatus]);

    useEffect(() => {
        setBarChart(computeData(filteredStructuralSummaryData, recommendationStatus, datesInSequence, dailyWeeklyTabValue, filterBy));
    }, [dailyWeeklyTabValue]);

    const structuralChartConfig = getStructuralChartConfig(recommendationStatus, filteredStructuralSummaryData, dailyWeeklyTabValue, barOnClickHandler, handleDailyWeeklyTabOnClick);

    return <ChartPanel
        key={structuralChartConfig.chartKey}
        chartType={CHART_TYPE.BAR_CHART}
        isLoading={isUndefined(filteredStructuralSummaryData)}
        chartData={barChart}
        configChart={structuralChartConfig}
        toolbarConfig={{
            isShowToolbar: true,
            gridChartIconOnClickHandler: gridChartIconOnClickHandler
        }}
        apiErrorMessage={false}
    >
    </ChartPanel>;
};

ChartRecommendationStructural.propTypes = {
    searchCriteriaPayload: object.isRequired,
    recommendationStatus: string,
    barOnClickHandler: func,
    gridChartIconOnClickHandler: func
};

export default ChartRecommendationStructural;
